var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__clock--system icon--style--fill icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 1a11 11 0 1011 11A11 11 0 0012 1zm4.707 15.707a1 1 0 01-1.414 0l-4-4A1 1 0 0111 12V6a1 1 0 012 0v5.586l3.707 3.707a1 1 0 010 1.414z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }